import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { User } from "./user";
import { apis } from "./apis";
import { environment } from "./environment";
// import { Http, ResponseContentType } from "@angular/http";

@Injectable()
export class CrudService {
  public url: string;
  public identity;
  public token;

  constructor(private _http: HttpClient) {
    this.url = environment.apiUrl;
  }

  ifapi(seccion){
    let api = seccion
    if (seccion in apis){
      api = apis[seccion]
    }
    
    return api
  }

  // Login
  login(params): Observable<any> {
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    return this._http.post(this.url + "api/v1/login/", params, {
      headers: headers,
    });
  }

  getUser(token, seccion): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Authorization", "Token " + token);
    return this._http.get(this.url + seccion, { headers: headers });
  }

  // End Login

  postData(seccion, token, params): Observable<any> {
    // let headers = new HttpHeaders().set("Content-Type", "application/json")
    //  .set("Authorization", token);
    let headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Authorization", "Token " + token);

    return this._http.post(this.url + "api/v1/" + this.ifapi(seccion), params, {
      headers: headers,
    });
  }

  putData(seccion, token, params): Observable<any> {
    // let headers = new HttpHeaders().set("Content-Type", "application/json")
    //  .set("Authorization", token);
    let headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Authorization", "Token " + token);
    return this._http.put(
      this.url + "api/v1/" +this.ifapi(seccion),
      params,
      { headers: headers }
    );
  }

  deleteData(token, seccion, id): Observable<any> {
    // let headers = new HttpHeaders().set("Content-Type", "application/json")
    //  .set("Authorization", token);
    let headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Authorization", "Token " + token);
    return this._http.delete(this.url + "api/v1/" + this.ifapi(seccion) + "/" + id, {
      headers: headers,
    });
  }

  getApi(seccion, token, params={}): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Authorization", "Token " + token);
    return this._http.get(seccion, {
      headers: headers,
      params:params
    });
  }

  getData(seccion, token, params={}): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Authorization", "Token " + token);
    return this._http.get(this.url + "api/v1/" + this.ifapi(seccion), {
      headers: headers,
      params:params
    });
  }

  getDataPage(seccion, page): Observable<any> {
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    return this._http.get(
      this.url + "api/v1/" + this.ifapi(seccion) + "?page=" + page,
      { headers: headers }
    );
  }

  getValue(seccion, token, id): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Authorization", "Token " + token);
    return this._http.get(this.url + "api/v1/" + this.ifapi(seccion) + "/" + id, {
      headers: headers,
    });
  }

  getTable(token, seccion, id, attr): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Authorization", "Token " + token);
    return this._http.get(
      this.url + "api/v1/" + this.ifapi(seccion) + "/" + id + "/" + this.ifapi(attr),
      { headers: headers }
    );
  }

  exportExcel(token, seccion, params={}): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/ms-excel")
      .set("Authorization", "Token " + token);

    return this._http.get(this.url + "api/v1/" + this.ifapi(seccion), {
      headers: headers,
      responseType: "blob",
      params:params
    });
  }
  
  exportPDF(token, seccion, params={}): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/pdf")
      .set("Authorization", "Token " + token);

    return this._http.get(this.url + "api/v1/" + this.ifapi(seccion), {
      headers: headers,
      responseType: "blob",
      params:params
    });
  }

  postFile(seccion, token, fileToUpload: File, data): Observable<any> {
    const formData: FormData = new FormData();
    let headers = new HttpHeaders().set("Authorization", "Token " + token);
    formData.append('file', fileToUpload, fileToUpload.name);
    for(let dato in data){
      formData.append(dato, data[dato]);
    }
    return this._http.post(this.url + "api/v1/" + this.ifapi(seccion), formData, { headers: headers })
      
  }
  getFile(seccion, token, params={}): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Authorization", "Token " + token);
    return this._http.get(this.url + "api/v1/" + this.ifapi(seccion),
      {
        headers: headers,
        params:params,
        responseType: 'text',
        reportProgress:true
      },
    );
  }
}
